/* Top Market — bandeau d'accueil : flèches, points de repère, défilement automatique. */
(() => {
  if (customElements.get('tm-vedette')) return;

  const MOUVEMENT_REDUIT = window.matchMedia('(prefers-reduced-motion: reduce)');

  class TmVedette extends HTMLElement {
    connectedCallback() {
      this.piste = this.querySelector('[data-tm-piste]');
      this.diapos = Array.from(this.querySelectorAll('[data-tm-diapo]'));
      this.points = Array.from(this.querySelectorAll('[data-tm-point]'));
      this.courante = 0;
      this.abandon = new AbortController();
      const options = { signal: this.abandon.signal };
      if (!this.piste || this.diapos.length === 0) return;
      this.marquer(0);
      if (this.diapos.length < 2) return;

      const precedent = this.querySelector('[data-tm-precedent]');
      const suivant = this.querySelector('[data-tm-suivant]');
      if (precedent) precedent.addEventListener('click', () => this.aller(this.courante - 1), options);
      if (suivant) suivant.addEventListener('click', () => this.aller(this.courante + 1), options);
      this.points.forEach((point, rang) => point.addEventListener('click', () => this.aller(rang), options));

      // La diapositive visible donne le point de repère actif, que l'on défile au doigt ou aux flèches.
      this.observateur = new IntersectionObserver((entrees) => {
        entrees.forEach((entree) => {
          if (entree.isIntersecting) this.marquer(this.diapos.indexOf(entree.target));
        });
      }, { root: this.piste, threshold: 0.6 });
      this.diapos.forEach((diapo) => this.observateur.observe(diapo));

      this.piste.addEventListener('keydown', (evenement) => {
        if (evenement.key === 'ArrowRight') {
          evenement.preventDefault();
          this.aller(this.courante + 1);
        } else if (evenement.key === 'ArrowLeft') {
          evenement.preventDefault();
          this.aller(this.courante - 1);
        }
      }, options);

      // Éditeur de thème : montrer la diapositive du bloc sélectionné.
      this.addEventListener('shopify:block:select', (evenement) => {
        const rang = this.diapos.indexOf(evenement.target.closest('[data-tm-diapo]'));
        if (rang < 0) return;
        this.arreter();
        this.aller(rang);
      }, options);

      const delai = Number(this.dataset.auto) * 1000;
      if (delai > 0 && !MOUVEMENT_REDUIT.matches) {
        const demarrer = () => {
          this.arreter();
          this.minuterie = setInterval(() => this.aller(this.courante + 1), delai);
        };
        ['pointerenter', 'focusin', 'touchstart'].forEach((type) => {
          this.addEventListener(type, () => this.arreter(), { signal: this.abandon.signal, passive: true });
        });
        ['pointerleave', 'focusout'].forEach((type) => this.addEventListener(type, demarrer, options));
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.arreter();
          else demarrer();
        }, options);
        demarrer();
      }
    }

    disconnectedCallback() {
      if (this.abandon) this.abandon.abort();
      if (this.observateur) this.observateur.disconnect();
      this.arreter();
    }

    arreter() {
      clearInterval(this.minuterie);
    }

    aller(rang) {
      const total = this.diapos.length;
      const cible = ((rang % total) + total) % total;
      this.piste.scrollTo({ left: this.diapos[cible].offsetLeft, behavior: MOUVEMENT_REDUIT.matches ? 'auto' : 'smooth' });
    }

    marquer(rang) {
      if (rang < 0) return;
      this.courante = rang;
      this.points.forEach((point, i) => {
        if (i === rang) point.setAttribute('aria-current', 'true');
        else point.removeAttribute('aria-current');
      });
    }
  }

  customElements.define('tm-vedette', TmVedette);
})();
